module.exports = __webpack_public_path__ + "static/media/image18.024f3dbf.jpg";